import { initializeFirebaseAnalytics } from "./firebase";

type AnalyticsParameter = unknown;

export async function trackEvent(
  name: string,
  parameters: Record<string, AnalyticsParameter> = {},
) {
  try {
    const analytics = await initializeFirebaseAnalytics();
    if (!analytics) return;
    const { logEvent } = await import("firebase/analytics");
    logEvent(analytics, name, parameters);
  } catch {
    // La analítica nunca debe interrumpir una acción del usuario.
  }
}

export function trackEventOnce(
  eventKey: string,
  name: string,
  parameters: Record<string, AnalyticsParameter> = {},
) {
  if (typeof window === "undefined") return Promise.resolve(false);
  const storageKey = `socrattica:analytics-event:${eventKey}`;
  try {
    if (window.localStorage.getItem(storageKey)) return Promise.resolve(false);
    window.localStorage.setItem(storageKey, new Date().toISOString());
  } catch {
    // El evento aún puede enviarse si el navegador bloquea localStorage.
  }

  return trackEvent(name, parameters).then(() => true);
}

export function trackPageView(path: string, title: string) {
  if (typeof window === "undefined") return Promise.resolve();
  return trackEvent("page_view", {
    page_location: new URL(path, window.location.origin).href,
    page_path: path,
    page_title: title,
  });
}
